"use client"

import { changeI18nLanguage } from "@/languages/i18n"
import React, { createContext, useContext, useEffect, useState } from "react"

const LanguageContext = createContext({
  language: "vi",
  changeLanguage: async (lang: string) => {},
})

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [language, setLanguage] = useState("vi")

  const changeLanguage = async (lang: string) => {
    setLanguage(lang)
    await changeI18nLanguage(lang)
    localStorage.setItem("language", lang)
    window.location.reload()
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const savedLanguage = localStorage.getItem("language")
      if (savedLanguage) {
        setLanguage(savedLanguage)
        void changeI18nLanguage(savedLanguage)
      }
    }
  }, [])

  return <LanguageContext.Provider value={{ language, changeLanguage }}>{children}</LanguageContext.Provider>
}

export const useLanguage = () => useContext(LanguageContext)
